







































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { formRules } from "@/common/util/validator";
import { Public } from "@/http/api_Public";
import { permissonRoutes } from "@/router";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import store from "../../vuex/modules/login";
var md5 = require("js-md5");
@Component({
  components: {},
})
export default class Login extends Vue {
  @Action("login/getjurisdictionArray") getjurisdictionArray;
  @Action("login/setChecked") setChecked;
  @Action("login/returnRoutes") returnRoutes;
  public $refs!: {
    loginForm1: HTMLFormElement;
    loginForm: HTMLFormElement;
  };
  /**登陆名称 */
  public loginType: any = "手机号登录";
  public canShow: any = false;
  public passLogin: any = true;
  public formRules: any = formRules;
  public btnMessage: any = "获取验证码";
  public toastText: any = "";
  public disYzm = false;
  public loginForm1 = {
    phone: "",
    smscode: "",
    username: "",
  };
  permissonRoutes = permissonRoutes;
  //自动登陆勾选框
  checked = false;
  public loginForm = {
    shopno:"",
    pwd: "",
    jobNumber: "",
  };
  loginInfo = {};
  auth = [];
  openIcp() {
    window.open("https://beian.mps.gov.cn/#/query/webSearch", "_blank");
  }
  async mounted() {
     localStorage.setItem("isPad",'false');
    this.loginInfo = JSON.parse(localStorage.getItem("loginInfo"));
    this.loginForm.shopno = this.loginInfo['shopNo']?this.loginInfo['shopNo']:'';
    this.loginForm.pwd = this.loginInfo['pwd']?this.loginInfo['pwd']:'';
    this.loginForm.jobNumber = this.loginInfo['jobNumber']?this.loginInfo['jobNumber']:'';
  }
  async created() {
    // let token = localStorage.getItem("dayChecked");
    // console.log("token", token);

    // if (token == "true") {
    //   let routers = JSON.parse(localStorage.getItem("routers"));
    //   this.$nextTick(async () => {
    //     this.$router.push(`${routers[0].children[0].path}`);
    //   });
    // }
  }
  public changeLogin() {
    this.passLogin = !this.passLogin;
    this.loginType = !this.passLogin ? "账户密码登录" : "手机号登录";
  }
  public timer = null;
  public async getCode() {
    let reg = /^1[3456789]\d{9}$/;
    let vaild = reg.test(this.loginForm1.phone);
    if (!vaild) {
      this.$message.warning("手机号输入错误！");
      return;
    }
    // let result = await Public.GetSendAsync({ phone: this.loginForm1.phone });
    // if (this.btnMessage !== "获取验证码") return;
    // this.btnMessage = 60;
    // this.disYzm = true;
    // this.timer = setInterval(() => {
    //   if (this.btnMessage == 0) {
    //     window.clearInterval(this.timer);
    //     this.btnMessage = "获取验证码";
    //     this.disYzm = false;
    //     return;
    //   }
    //   --this.btnMessage;
    // }, 1000);
  }
  /**账户登陆按钮 */
  public async handleLogin() {
    let valid = await this.$refs.loginForm.validate().catch(Boolean);
    if (!valid) {
      this.$message.warning('不能为空！');
      return;
    }
    let pwd = md5(this.loginForm.pwd);
    let obj = Object.assign({}, this.loginForm, { pwd: pwd,isOfficial:true });
    this.$nextTick(async () => {
        let result = await Public.GetUsersLogin(obj);
        await this.JumpPage(result);
    });
  }
  /**验证码登陆 */
  public async handleLogin1() {
    let valid = await this.$refs.loginForm1.validate().catch(Boolean);
    if (!valid) {
      this.canShow = true;
      this.toastText = "请输入正确的验证码或用户名";
      return;
    } else {
      this.canShow = false;
    }
    // let result = await Public.GetTbManageChildUsersLogin(this.loginForm1);
    // this.JumpPage(result);
  }
  /**跳转登陆 */
  public async JumpPage(result) {
    console.log("result", result);
    localStorage.setItem("userInfo",JSON.stringify(result));
    if (this.checked == true) {
      store.state.dayChecked = true;
      localStorage.setItem("token", result.token);
    } else {
      store.state.dayChecked = false;
      sessionStorage.setItem("token", result.token);
    }
    let resShop = await Public.GetTbShopById({id:result.shopId})
    // localStorage.setItem("padShopInfo",JSON.stringify(resShop))
    let form = Object.assign({},result,{
        pwd:this.loginForm.pwd,
        shopNo:resShop.shopNo
    })
    localStorage.setItem("loginInfo",JSON.stringify(form));
    let auth = [];
    // if(result.userName == 'admin'){
    //     await (this as any ).cleanrouter()
    //     await (this as any).allrouter(permissonRoutes)
    //     auth = Object.keys(listroute)
    //     // auth = ['xbpa7', 'r6h2b', 'nbdq1','furng','bblt3','i27s0','1k0bw', 'dxf67', 'so2l8','g8nl3', 'ivbre', 'yqa2u','jyass', 'tdx8e', '8qrfq', 'kwfj3','ruakk', 'fyw7m','f9c50']
    // }else{
    //     /**用户功能权限列表 */
    //     let res = await TbUsers.GetTbFunctionalAuthorityByUserId({userId:id})
    //     auth = res.map(v=>v.menuAlias)
    // }
    /**用户功能权限列表 */
    // let res = await TbUsers.GetTbFunctionalAuthorityByUserId({ userId: id });
    // auth = res.map((v) => v.menuAlias);
    // console.log("auth", auth);
    // auth.push("const1");
    // auth.indexOf("kwfj3") == -1 ? auth.push("kwfj3") : null;
    // await this.getjurisdictionArray(auth);
    // let routers = await this.returnRoutes();
    let routers = this.permissonRoutes;
    localStorage.setItem("routers", JSON.stringify(routers));
    this.$nextTick(async () => {
      // if (routers.length <= 0) {
      //   this.$router.push("/401");
      // } else {
      this.$router.push(`${routers[0].children[0].path}`);
      // }
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/home/Login.vue